module.exports = __webpack_public_path__ + "img/funding@2x.b813bd02.png";